import { Loader2, RefreshCw, ScrollText } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export function AuditTab({ auditLogs, auditTotal, auditPage, setAuditPage, auditFilter, setAuditFilter, auditActions, loadingAudit, fetchAuditLogs }) {
  return (
    <div className="space-y-4" data-testid="audit-log-section">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">Admin Audit Log</h2>
        <div className="flex items-center gap-2">
          <Select value={auditFilter} onValueChange={(v) => { setAuditFilter(v); setAuditPage(0); }}>
            <SelectTrigger className="w-[200px] bg-surface border-[#262626]" data-testid="audit-filter">
              <SelectValue placeholder="Filter by action" />
            </SelectTrigger>
            <SelectContent className="bg-surface border-[#262626]">
              <SelectItem value="all">All Actions</SelectItem>
              {auditActions.map(a => <SelectItem key={a} value={a}>{a.replace(/_/g, ' ')}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button variant="outline" size="sm" onClick={() => fetchAuditLogs(auditPage, auditFilter)} data-testid="audit-refresh-btn"><RefreshCw className="w-4 h-4" /></Button>
        </div>
      </div>

      {loadingAudit ? (
        <div className="flex justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-lime" /></div>
      ) : auditLogs.length === 0 ? (
        <div className="text-center py-12 text-[#A1A1AA]">
          <ScrollText className="w-12 h-12 mx-auto mb-3 opacity-40" />
          <p>No audit log entries yet.</p>
          <p className="text-sm mt-1">Admin actions will appear here automatically.</p>
        </div>
      ) : (
        <>
          <div className="space-y-2">
            {auditLogs.map(log => (
              <div key={log.id} className="bg-surface border border-[#262626] rounded-lg p-4" data-testid={`audit-entry-${log.id}`}>
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <Badge variant="outline" className="text-xs capitalize shrink-0">{log.action.replace(/_/g, ' ')}</Badge>
                      <span className="text-xs text-[#A1A1AA] capitalize">{log.target_type}</span>
                    </div>
                    <p className="text-sm">{log.details}</p>
                    <p className="text-xs text-[#666] mt-1">by {log.admin_email}</p>
                  </div>
                  <span className="text-xs text-[#666] shrink-0">{new Date(log.created_at).toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-between pt-4">
            <p className="text-sm text-[#A1A1AA]">Showing {auditPage * 20 + 1}-{Math.min((auditPage + 1) * 20, auditTotal)} of {auditTotal}</p>
            <div className="flex gap-2">
              <Button variant="outline" size="sm" disabled={auditPage === 0} onClick={() => setAuditPage(p => p - 1)} data-testid="audit-prev">Previous</Button>
              <Button variant="outline" size="sm" disabled={(auditPage + 1) * 20 >= auditTotal} onClick={() => setAuditPage(p => p + 1)} data-testid="audit-next">Next</Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
